import {useQuery} from 'react-query';
import getUnSeenChat from '.';

const useGetUnSeenChat = () => {
  const {data, isLoading} = useQuery(['unSeenChat'], getUnSeenChat);

  return {data, isLoading};
};

export default useGetUnSeenChat;
